import {
    MtDriveCloud,
    MtDriveCloudIndex,
} from "server/models"

import { POST } from "client/store/utils"

export * from "./aws"
export * from "./google"
export * from "./microsoft"

export const CreateCloudDriveSettings = (props: MtDriveCloud) => (
    POST(
        "/mtDriveCloud/create",
        JSON.stringify(props),
    )
)

export const DeleteCloudDriveSettings = (props: MtDriveCloudIndex) => (
    POST(
        "/mtDriveCloud/delete",
        JSON.stringify(props),
    ).then((removedRows: number) => removedRows)
)
